import GmhLogin from './gmh-login'
import GmhRegistration from './gmh-registration'
import GmhForgotPassword from './gmh-forgot-password'
import GmhResetPassword from './gmh-reset-password'
import Loging2FA from './login-2fa'
import ReInputEyeIcon from './re-input-eye-icon'

export default {
    GmhLogin,
    GmhRegistration,
    GmhForgotPassword,
    GmhResetPassword,
    Loging2FA,
    ReInputEyeIcon,
}
